import classnames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "../../svg-icon/svg-icon";
import styles from "./close-button.css";

function CloseButton({ className, onClick }) {
    return (
        <button onClick={onClick} className={classnames(className, styles.button)}>
            <SVGIcon name="cross" />
        </button>
    );
}

export default CloseButton;

CloseButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};
